import FlatJsonReader from './Classes/FlatJsonReader';
import HierarchicalJsonReader from './Classes/HierarchicalJsonReader';

/**
 * @type {JsonReader|null}
 */
window.esgReaderInstance = null;

document.querySelectorAll('a[data-test]').forEach(
  /**
   * @param {HTMLLinkElement} el
   */ (el) => {
    el.addEventListener('click', async (clickEvent) => {
      clickEvent.preventDefault();

      if (el.dataset.test === 'json-flat') {
        window.esgReaderInstance = new FlatJsonReader(el.href);
      } else if (el.dataset.test === 'json-hierarchical') {
        window.esgReaderInstance = new HierarchicalJsonReader(el.href);
      } else {
        return false;
      }

      return window.esgReaderInstance.show();
    });
  }
);
